const songUpdate = [
  {
    product: "Alpha 2",
    years: [
      {
        year: 2024,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/gox2wut4s0jjc22/Alpha_2_12-2024.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/kceisn0egjrwszc/Alpha_2_11-2024.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/umvfvl9qflekhcz/Alpha_2_10-2024.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/gtk654xhfdo7pam/Alpha_2_09-2024.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/wwrlnk5dozzbt41/Alpha_2_08-2024.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/opgprkoqxrcjkjr/Alpha_2_07-2024.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/f0vse5nx2rpxfbq/Alpha_2_06-2024.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/bzllm0q1q99qqu2/Alpha_2_05-2024.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/p79cq6cb5q2tkl7/Alpha_2_04-2024.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/4fyw5m9f9rhlmnt/Alpha_2_03-2024.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/i6459qssrix1rh1/Alpha_2_02-2024.zip/file",
          },
          {
            month: "January",
            link: "https://cdn.shopify.com/s/files/1/2581/7224/files/zip-6.png?2449845585766634820",
          },
        ],
      },
      {
        year: 2023,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/qdelaytv6pugtib/Alpha_2_12-2023.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/s0na3hi3zq0se74/Alpha_2_11-2023.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/0ruatu7ou405ylu/Alpha_2_10-2023.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/5697rab4dfcfsni/Alpha_2_09-2023.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/1f525nv2vk2w0w0/Alpha_2_08-2023.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/kumx19b4mfrptdy/Alpha_2_07-2023.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/n6mrl6h3xwoq6w3/Alpha_2_06-2023.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/ty9ol9wycw9qnnt/Alpha_2_05-2023.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/6p5uu0idz8bm0il/Alpha_2_04-2023.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/0s0yokc5qjwvm76/Alpha_2_03-2023.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/p0437glsl85zovh/Alpha_2_02-2023.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/i9qkx0w1g4h1zwj/Alpha_2_01-2023.zip/file",
          },
        ],
      },
    ],
  },
  {
    product: "Alpha",
    years: [
      {
        year: 2026,
        months: [
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/839k981eaaqtd82/Alpha_11-2026.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/69ja79idrmzv9t1/Alpha_10-2026.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/phqynbuqlrb2f41/Alpha_09-2026.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/g8la4l1c1bh7azc/Alpha_08-2026.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/k8fi7i78a9jtb5q/Alpha_07-2026.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/iylia7fl23ay6u9/Alpha_06-2026.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/62ewa6yof8ca1aa/Alpha_05-2026.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/s5mwugrbui9zlwh/Alpha_04-2026.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/2v3tzmce2yq2npy/Alpha_03-2026.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/76wc513c64q93lh/Alpha_02-2026.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/3such253axfdzu0/Alpha_01-2026.zip/file",
          },
        ],
      },
      {
        year: 2025,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/77dokda4plt5thw/Alpha_12-2025.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/v3hpfc0wlj57nvh/Alpha_11-2025.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/60qs8kojsumgu95/Alpha_10-2025.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/9j0shbldeh8b8mg/Alpha_09-2025.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/wr68eyarqgf75gg/Alpha_08-2025.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/omg5gihv5zaobbz/Alpha_07-2025.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/pj66we0wn79bzxt/Alpha_06-2025.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/2r5m98bbcdh62zj/Alpha_05-2025.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/0k1b8x3l84g3vur/Alpha_04-2025.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/vn4mhhjpvbjbdin/Alpha_03-2025.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/57qvrosthr6l6yk/Alpha_02-2025.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/gupu38bf4gxr8ca/Alpha_01-2025.zip/file",
          },
        ],
      },
      {
        year: 2024,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/4oqri07usg0el0j/Alpha_12-2024.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/tpi1gfie2wx04zp/Alpha_11-2024.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/9460lnfivwvbwez/Alpha_10-2024.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/alpgbmycoo0pxr7/Alpha_09-2024.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/01jo75wa0ptnx8v/Alpha_08-2024.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/va9ojvapz7wbch8/Alpha_07-2024.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/tq1e0stxie6fhxf/Alpha_06-2024.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/26it80esdgdg9t0/Alpha_05-2024.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/peaw4tk5jfn5zen/Alpha_04-2024.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/izup0gnv1cyng4r/Alpha_03-2024.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/py9q0wfaqjrf63h/Alpha_02-2024.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/ms22zxc61btku6h/Alpha_01-2024.zip/file",
          },
        ],
      },
      {
        year: 2023,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/5rlxppqnw4b014m/Alpha_12-2023.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/9guqp0iralq0uva/Alpha_11-2023.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/063itkhppyzrfel/Alpha_10-2023.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/wzx21hvwmnt0jq2/Alpha_09-2023.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/fox5nuozh25059y/Alpha_08-2023.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/8wamw2f7z5m6hma/Alpha_07-2023.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/4bl6hyslst633pk/Alpha_06-2023.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/5xbnivak1ksw7hc/Alpha_05-2023.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/8c82la1t2jxf6xa/Alpha_04-2023.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/4m2p4zwdj1nypf3/Alpha_03-2023.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/xjyutl3y9c5aoyk/Alpha_02-2023.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/e7hrsdvmloi4y3c/Alpha_01-2023.zip/file",
          },
        ],
      },
      {
        year: 2022,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/d3dnzd7neu1sd2g/Alpha_12-2022.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/orr4b0mf5ycl0kr/Alpha_11-2022.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/n853p9w9pj5wu7i/Alpha_10-2022.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/da0znnxrnwwqilh/Alpha_09-2022.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/r9wqrtqiuz5d7pf/Alpha+08-2022.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/tfhiicuj1ulgrx5/Alpha_07-2022.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/bl944ynzlhykgmc/Alpha_06-2022.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/ixrgozc2l2av92k/Alpha_05-2022.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/d7m60fsk6voewm0/Alpha_04-2022.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/ms0t5nrqgl41tsd/Alpha_03-2022.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/ik9jthk9k0algmc/Alpha_02-2022.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/omxco4gar2tifgs/Alpha_01-2022.zip/file",
          },
        ],
      },
      {
        year: 2021,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/q7146hchxqxhx90/Alpha+12-2021.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/blybr8fd3bg4k29/Alpha_11-2021.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/cp12p1zrkpu5buk/Alpha_10-2021.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/qfs0ab0wxi4u0nk/Alpha_09-2021.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/yr7a4bd5wz5v6t3/Alpha_08-2021.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/x4o7orfzcmmc0yk/Alpha+07-2021.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/uorufbctb2a1h57/Alpha+06-2021.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/lpopvchk2fdajc6/Alpha_05-2021.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/ugpqdr4nxkhitwx/Alpha_04-2021.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/3qg7chx2nfkcukh/Alpha_03-2021.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/rew8d1o5u3szisb/Alpha_02-2021.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/6jzgra1lpo4p145/Alpha_01-2021.zip/file",
          },
        ],
      },
      {
        year: 2020,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/w5yed4szf2kuikn/Alpha_12-2020.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/iepsm3iz7px3bup/Alpha_11-2020.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/v5i8hn7nrp09h1t/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/tsrofkcvmyc2xfz/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/qt3plvmv984lsmv/Alpha_08-2020.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/2yserq64vprtg89/Alpha_07-2020.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/1jfl7zq94560m17/Alpha_06-2020.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/45k8kyb45xxvb0c/Alpha_05-2020.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/7947fztzq99b4ez/Alpha_04-2020.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/ony48ts1os0ix9q/Alpha_03-2020.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/rlvovegqvmwaapy/Alpha_02-2020.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/ecgahgn80rwllmv/Alpha_01-2020.zip/file",
          },
        ],
      },
      {
        year: 2019,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/z48odpr3kapf6cm/Alpha_12-2019.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/ghkutb8eyddo3q2/Alpha_11-2019.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/0gosz3jtj27j8x7/Alpha_10-2019.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/jfktnc01uqaprvr/Alpha_09-2019.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/4renabc0u4r6k56/Alpha_08-2019.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/1230rwk5vaurden/Alpha_07-2019.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/pdm2ytab3kmgu2f/Alpha_06-2019.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/6879ojccfdafg39/Alpha_05-2019.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/fjcy2okx5tpt9xj/Alpha_04-2019.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/p40wkv2mbc9eubz/Alpha_03-2019.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/awy555973za7211/Alpha_02-2019.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/6vspt4la661h6ui/Alpha_01-2019.zip/file",
          },
        ],
      },
      {
        year: 2018,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/a0ax68p1b0jg2as/Alpha_12-2018.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/mur58ecj6xqj1cr/Alpha_11-2018.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/q8em24df4xxna40/Alpha_10-2018.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/7rf246hhb7286zb/Alpha_09-2018.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/ss2im3punkl5q5q/Alpha_08-2018.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/nu7a2gng2twe6bh/Alpha_07-2018.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/8ft5z2kk5fo3plk/Alpha_06-2018.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/na9wdm92ahme2qf/Alpha_05-2018.zip",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/qk8897p29bjv99u/Alpha_04-2018.zip",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/1dy7ryut015wcw1/2018_March_Alpha.zip",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/60aajbj5snufd8e/Alpha_02-2018.zip",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/uudou22a71dh5qu/Alpha_01-2018.zip",
          },
        ],
      },
      {
        year: 2017,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/ez0086zacznqjus/ALPHA_DEC_2017.zip",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/mq36dq01mb8d2l5/2017_November_Alpha.zip",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/9ha615g55vig144/2017_October_Alpha.zip",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/5a4e630mrqhu8lq/2017_September_Alpha.zip",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/38hyaae7n6dkkfy/2017_August_Alpha.zip",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/xw5bllm4atl05d8/2017_July_Alpha.zip",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/fci4cvlnu4eydqt/2017_June_Alpha.zip",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/kwada3s3s3jom1u/2017_May_Alpha.zip",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/xvlnvb5yjiqp25e/2017_April_Alpha.zip",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/qaedqib95trjuee/2017_March_Alpha.zip",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/eu88ugj1ct16a0q/2017_February_Alpha.zip",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/k9l4h2a5qot25sk/2017_January_Alpha.rar",
          },
        ],
      },
      {
        year: 2016,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/brx02q9b9msss95/2016_December_Alpha.rar",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/brx02q9b9msss95/2016_December_Alpha.rar",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/96umzhpyqvqc6ea/2016_October_Alpha.rar",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/3bwj8qvp2nmxrgg/2016_September_Alpha.rar",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/6r38dproyskdgqd/2016_August_Alpha.rar",
          },
        ],
      },
    ],
  },
  {
    product: "Cello 2",
    years: [
      {
        year: 2026,
        months: [
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/zw8e595vz3q6wjd/Cello_11-2026.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/98nkpmcg4ndas6q/Cello_10-2026.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/4yiyvo012qm9155/Cello_09-2026.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/89b4jkkdc66pofr/Cello_08-2026.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/lc6jg0dl0yjr57m/Cello_07-2026.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/v6du89k6mfc4dhc/Cello_06-2026.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/53ti0bfnrgwt3uv/Cello_05-2026.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/v3eux2ns53q8qxu/Cello_04-2026.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/i5zswj2dvs0p80l/Cello_03-2026.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/ormlr0yhguio6hj/Cello_02-2026.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/nvittdbmfxouhf5/Cello_01-2026.zip/file",
          },
        ],
      },
      {
        year: 2025,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/i96twx7w1p02y8s/Cello_12-2025.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/ycslrh4boo63zbt/Cello_11-2025.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/939i411afzkq154/Cello_10-2025.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/2szwl1szteycp5l/Cello_09-2025.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/5jaoydobpy4mrpd/Cello_08-2025.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/awhyous8tb8podk/Cello_07-2025.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/xv95o5ai6xdao7y/Cello_06-2025.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/9lzgar6z5yjshwb/Cello_05-2025.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/23vr4xcsbzanpsw/Cello_04-2025.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/a8yb4zab4zrvvip/Cello_03-2025.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/4jf1kiqb65f5bp6/Cello_02-2025.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/rhl9dtobsmpxbjt/Cello_01-2025.zip/file",
          },
        ],
      },
      {
        year: 2024,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/bq6vste84q02sm5/Cello_12-2024.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/526ns9bvdlmh1io/Cello_11-2024.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/wu0ma5suk7q361u/Cello_10-2024.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/535rvjymqhhgffn/Cello_09-2024.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/nqgbub5waf2r20k/Cello_08-2024.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/6qjeqp9vbcoa7g3/Cello_07-2024.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/mcwexba43vvk27o/Cello_06-2024.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/9pje5gunifvqtb4/Cello_05-2024.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/04hrwi9u9cokxp3/Cello_04-2024.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/fh8gsdyqey6a0cq/Cello_03-2024.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/c2xcllqlsf3imna/Cello_02-2024.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/b6v10alci34vbis/Cello_01-2024.zip/file",
          },
        ],
      },
      {
        year: 2023,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/fn5pkiy2hx4gkmj/Cello_12-2023.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/pv5gdqxxeps91ao/Cello_11-2023.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/4shh8uvddz27trc/Cello_10-2023.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/c5wbmp1d6wyuw7k/Cello_09-2023.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/4pbsi83p2gslhv6/Cello_08-2023.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/m4c6hmrib1a1t23/Cello_07-2023.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/fuusw0ojhrakgxz/Cello_06-2023.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/a3fttxhwggg9kt6/Cello_05-2023.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/dwc2qdz6sit75j5/Cello_04-2023.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/yxwul2zrg474a03/Cello_03-2023.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/itjppxx3qpv3s3x/Cello_02-2023.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/aor8kr6k7rzsevf/Cello_01-2023.zip/file",
          },
        ],
      },
      {
        year: 2022,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/bdm8vzdpvqfm1av/Cello_12-2022.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/mxs1jj76d9z7k99/Cello_11-2022.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/ral8lg2j6ugi6bi/Cello_10-2022.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/0tcn7osatdzovni/Cello_09-2022.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/r6fannjpcnvs0cp/Cello+08-2022.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/3bl04goxas5hejq/Cello_07-2022.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/nuw8nkplk5fpq3r/Cello_06-2022.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/9rj5ais1nxqah4o/Cello_05-2022.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/bdhsvi71gfsr3a1/Cello_04-2022.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/oyyagfe6ycsajd8/Cello_03-2022.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/jwmngujbb1w50vs/Cello_02-2022.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/bo44e6bgo3s3yo1/Cello_01-2022.zip/file",
          },
        ],
      },
      {
        year: 2021,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/naxtd7hyk3drouq/Cello+12-2021.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/663m49t182de9w1/Cello+11-2021.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/psp2gom0u3l30pz/Cello_10-2021.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/oda8oyrug2n6nwv/Cello_09-2021.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/11rmvtvr5dk3d9r/Cello_08-2021.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/pv9oduduyem7do5/Cello+07-2021.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/0cwbyxb84bau7x9/Cello+06-2021.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/8sxe9em85jktamk/Cello_05-2021.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/1sfzawcrynyh3yx/Cello_04-2021.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/ge9z28wmb9bi4en/Cello_03-2021.zip/file ",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/f33lp7v67t5evkm/Cello_02-2021.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/lmlee4b446ohzon/Cello_01-2021.zip/file",
          },
        ],
      },
      {
        year: 2020,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/8zr7y8r8iorlsxx/Cello_12-2020.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/0uiztstzr15zvmh/Cello_11-2020.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/mn2lrph4iil98qv/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/he8xsrhkia5f5e1/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/v9mznpwq62rvu9j/Cello_08-2020.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/0zug4isj6s9ze0p/Cello_07-2020.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/btbt6g1k2rdv8lg/Cello_06-2020.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/leqzbedm34m111a/Cello_05-2020.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/058wblgjfub8jem/Cello_04-2020.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/gjr22lgay72fd9a/Cello_03-2020.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/zq8gdwr526qqns5/Cello_02-2020_%25281%2529.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/z5nr3n7132ojstc/Cello_01-2020.zip/file",
          },
        ],
      },
      {
        year: 2019,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/quuxnf459sjw0o2/Cello_12-2019.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/9pofzw7nzeoge2j/Cello_11-2019.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/utx1jnmd6ad3w5i/Cello_10-2019.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/v53py0k73umntj5/Cello_09-2019.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/qdiza48f7p9wff6/Cello_08-2019.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/4aw3surygqhsc67/Cello_07-2019.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/4w9d6ob72ra1dam/Cello_06-2019.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/5zi4m3jqpf7ssab/Cello_05-2019.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/utxubbfnhlvo24q/Cello_04-2019.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/2l786u47in66urq/Cello_03-2019.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/eaxb00gnou709h5/Cello_02-2019.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/721n07wf2ec0sy3/Cello_01-2019.zip/file",
          },
        ],
      },
      {
        year: 2018,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/0a1rnm9cxxklgkx/Cello_12-2018%25282%2529.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/c3xbjll1ul357ln/Cello_11-2018.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/6k6bdm71rsbl6k1/Cello_10-2018.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/y6rd7qx3b35b9z0/Cello_09-2018.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/62t69tmyd8yfp12/Cello_08-2018.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/r18p2iba05c8v06/Cello_07-2018.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/fczhi937s9gis88/Cello_06-2018.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/fj1bmb4y4e9z9bt/Cello_05-2018.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/17dd0h1g3em4357/Cello_04-2018.zip",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/xm89ug4wp1o99dg/Cello_03-2018.zip",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/f90r74v2ejmt344/Cello_02-2018.zip",
          },
        ],
      },
    ],
  },
  {
    product: "Major HD-10",
    years: [
      {
        year: 2026,
        months: [
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/hhlul037fh3ct10/Major_11-2026.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/zjzto7tvuhtocla/Major_10-2026.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/nhpycbyx001lnre/Major_09-2026.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/r810t7ugmru4p36/Major_08-2026.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/x3gwmzacelzupat/Major_07-2026.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/et0icpsssd1ju0x/Major_06-2026.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/f0i0mttm1irf0px/Major_05-2026.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/gaqjjljwcm3wlnt/Major_04-2026.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/6812kan9y2gv01l/Major_03-2026.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/hkc1prt614tut9l/Major_02-2026.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/yedq3snkr6o5n89/Major_01-2026.zip/file",
          },
        ],
      },
      {
        year: 2025,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/8c6h9nqthpnbnda/Major_12-2025.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/nmyzmjrz4zjsvw9/Major_11-2025.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/p8a6a3arksb57lj/Major_10-2025.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/mkr84gbe5z4ei4u/Major_09-2025.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/jzxrmn4ldiab7vq/Major_08-2025.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/4sakj2npy7wogy1/Major_07-2025.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/d9c443pw1f67hhi/Major_06-2025.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/em6gzshfuw5v7kb/Major_05-2025.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/luc0oxuq839ovjp/Major_04-2025.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/d31v80nr23glngl/Major_03-2025.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/8nez4jl4sumgt7m/Major_02-2025.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/n9zn7xc8we8xgki/Major_01-2025.zip/file",
          },
        ],
      },
      {
        year: 2024,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/a83lbgv915tinl0/Major_12-2024.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/tqzo01fylejpto6/Major_11-2024.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/x63cpxhd4x3yxal/Major_10-2024.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/l51txotw7vyd2bh/Major_09-2024.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/zmsn48ujeh4ievs/Major_08-2024.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/22lkjkf939go0rs/Major_07-2024.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/qys0z0yyk5j4fsz/Major_06-2024.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/tg9d2hj18rnq3r6/Major_05-2024.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/3smxpve5tbvcyt6/Major_04-2024.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/10ik830ztsi0j5c/Major_03-2024.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/tuogxxpeo3wduaj/Major_02-2024.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/7p1an9bx6wtmu14/Major_01-2024.zip/file",
          },
        ],
      },
      {
        year: 2023,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/1czcxvn064s1ql4/Major_12-2023.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/3naj4gm5pv78k3n/Major_11-2023.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/tqx82k3hhr5g0av/Major_10-2023.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/62keq42txtszw4g/Major_09-2023.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/qsmalqeyx292tlc/Major_08-2023.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/kph0b70oftmp4a0/Major_07-2023.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/4amvkxy9j7bk1k4/Major_06-2023.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/mwet97eomwgl1zd/Major_05-2023.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/k27vms3czt6t4ew/Major_04-2023.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/7swiyfgiw4bnm3k/Major_03-2023.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/kddg2aunjb03ynl/Major_02-2023.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/9cam6jkhg9thvu2/Major_01-2023.zip/file",
          },
        ],
      },
      {
        year: 2022,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/0j180taqxd5aogx/Major_12-2022.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/46vsskbw01ghtr7/Major_11-2022.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/4v05ueg0n9zb2ut/Major_10-2022.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/gu4bshjc4iz2joz/Major_09-2022.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/ii8ggeoyjlz9tv7/Major+08-2022.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/dx8dk9e9mo5sv0p/Major_07-2022.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/tac44631s9wxdmj/Major_06-2022.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/2tv38ff9i7uy4w4/Major_05-2022.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/rpcr8da7s3jc8bb/Major_04-2022.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/4togjhk7foajygt/Major_03-2022.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/kf553lny09wgku0/Major_02-2022.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/g5p5oahb5vcdn0w/Major_01-2022.zip/file",
          },
        ],
      },
      {
        year: 2021,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/ebk3uqq57v8t2oj/Major+12-2021.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/k5zc3cd8pq3m8eh/Major+11-2021.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/1tgxc7inc7r2j2d/Major_10-2021.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/59gotrv03a9xeln/Major_09-2021.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/3lc88cu8339ew56/Major_08-2021.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/initcw06srkkw6o/Major+07-2021.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/w8060b7e3pgd80k/Major_06-2021.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/457hwsevjd7xuw5/Major_05-2021.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/5add5b13hsko330/Major_04-2021.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/ldim6ujoq5ejaz8/Major_03-2021.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/lzb08r09rqek899/Major_02-2021.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/v86nxcdf7ei77rv/Major_01-2021.zip/file",
          },
        ],
      },
      {
        year: 2020,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/a304l4n2s6d830j/Major_12-2020.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/iyqzc3n2z69sy2s/Major_11-2020.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/mk6o75vtyrycxg6/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/n38ilfguub3sylj/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/tlwzkos1mpe007z/Major_08-2020.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/gwjaqmb3i49nq74/Major_07-2020.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/ya0d13iwf9eudj3/Major_06-2020.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/8gdc2li3j5w2zjj/Major_05-2020.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/fot00n8a7g2m1iq/Major_04-2020.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/4c05ew6lzo5vj2r/Major_03-2020.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/wqhr3ttyutv2s8d/Major_02-2020.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/dwp2x1idvghrd3n/Major_01-2020.zip/file",
          },
        ],
      },
      {
        year: 2019,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/8pzdnk1c9ig7zw4/Major_12-2019.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/ra9apcjmuxlo0n8/Major_11-2019.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/4bqomr89retdgk4/Major_10-2019.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/9p9dngvor7yh559/Major_09-2019.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/swgz7agk5d62wh4/Major_08-2019.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/xald3e2o72p45qu/Major_07-2019.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/b5suob4k0q9fz0l/Major_06-2019.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/205r3qxzlqv7840/Major_05-2019.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/qi42jcczcdqzczi/Major_04-2019.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/1nlilll8b2b7r2t/Major_03-2019.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/i0aab6t7a6163m0/Major_02-2019.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/xly7oan450owga2/Major_01-2019.zip/file",
          },
        ],
      },
      {
        year: 2018,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/1bj8hgczc7d58jd/Major_12-2018.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/v0m7ja4vfsw146e/Major_11-2018.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/y0fqsba03cb5aea/Major_10-2018.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/esvaynhcyiizvso/Major_09-2018.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/1j81uq1mohv2tau/Major_08-2018.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/qqppx6b4rqqy6fl/Major_07-2018.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/hnncmpbbibuubns/Major_06-2018.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/hjq8kwn5c1l11px/Major_05-2018.zip",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/tt058hdzq853z73/Major_04-2018.zip",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/mddpgq8p8ngedgs/2018_March_HD_10.zip",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/b6zb6i4y6z7vo67/Major_02-2018.zip",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/tm9eg1ae7bo3ceg/Major_01-2018.zip",
          },
        ],
      },
      {
        year: 2017,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/9vm635y1ldcvv98/2017_December_2017.zip",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/025r4sktmqy6vf7/2017_November_HD-10.zip",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/4842bgbrjf4d41m/2017_October_HD-10.zip",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/t3quwz66250f8zz/2017_September_HD-10.zip",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/f8lncj4b2jn58px/2017_August_HD-10.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/q7z58amvqw4tbxc/2017_July_HD-10.zip",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/n8ux9u69tkmqc06/2017_June_HD-10.zip",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/7l966mczva2x7cr/2017_May_HD-10.zip",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/7bkfm2sgbos1h4d/2017_April_HD-10.zip",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/hi773z4c12riet9/2017_March_HD-10.zip",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/z79m4qf29jr1dch/2017_February_HD-10.zip",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/6u2ydhh888x7b9e/2017_January_HD-10.rar",
          },
        ],
      },
      {
        year: 2016,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/tvlhpvedb8ui643/2016_December.rar",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/ucxwa30ggoc66yt/2016_November.rar",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/a462f91fqgwrkku/2016_October.rar",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/3ukjiwxbx5o60c7/2016_September.rar",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/wa60qnqn0dhbxrj/2016_August.zip",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/nllh2zed2vd75z3/2016_July.zip",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/sjb67kqjt7k5f7u/2016_June.zip",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/ahnn648qfq0pgs9/2016_May.zip",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/hj9vv4aggjs6x4s/2016_April.zip",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/8w886x5i1uq1ikj/2016_March.zip",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/rjewc8dcq2d1ck7/2016_February.rar",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/rtj0xo1tsk0000y/2016_January.rar",
          },
        ],
      },
    ],
  },
  {
    product: "Piano XL HDD",
    years: [
      {
        year: 2026,
        months: [
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/b2e9cghlxfxhjj2/Piano_XL_HDD_11-2026.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/cjpg5uyaoixivd7/Piano_XL_HDD_10-2026.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/1fj4tla2raqtpg8/Piano_XL_HDD_09-2026.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/g6044291calw90v/Piano_XL_HDD_08-2026.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/pxcogdig15cuin2/Piano_XL_HDD_07-2026.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/5k8ouwp4r0lu2jw/Piano_XL_HDD_06-2026.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/5i0xj7fwbtmskpl/Piano_XL_HDD_05-2026.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/goq9i1ijc4ojpzd/Piano_XL_HDD_04-2026.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/vo4wvkw5rdsotz7/Piano_XL_HDD_03-2026.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/fa51igvpm6w98h4/Piano_XL_HDD_02-2026.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/hygc8gba5b7o5ih/Piano_XL_HDD_01-2026.zip/file",
          },
        ],
      },
      {
        year: 2025,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/1xo62o1ie3zneil/Piano_XL_HDD_12-2025.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/pvy5utouk62rfz4/Piano_XL_HDD_11-2025.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/2xmuk3jraojgpsx/Piano_XL_HDD_10-2025.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/nd8xatzkat4vlvj/Piano_XL_HDD_09-2025.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/jzq7tg2hmksj9mb/Piano_XL_HDD_08-2025.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/3ijr4nu0jhxtnrd/Piano_XL_HDD_07-2025.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/erpc9jy01kcqvk5/Piano_XL_HDD_06-2025.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/9dfbncjyhesjxce/Piano_XL_HDD_05-2025.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/u4yypxxe0sorzs5/Piano_XL_HDD_04-2025.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/pdxt3cy7eeyt3f3/Piano_XL_HDD_03-2025.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/kmvpq0lk7xs33x3/Piano_XL_HDD_02-2025.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/5dezg5akcuvpj08/Piano_XL_HDD_01-2025.zip/file",
          },
        ],
      },
      {
        year: 2024,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/3zu5zvqfntah4ou/Piano_XL_HDD_12-2024.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/gavtnglc8okwte8/Piano_XL_HDD_11-2024.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/n38x36whb80m2s3/Piano_XL_HDD_10-2024.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/6yam4pgav5ax0r7/Piano_XL_HDD_09-2024.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/e2hag21hir9x9qa/Piano_XL_HDD_08-2024.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/6gbqksu9recw6em/Piano_XL_HDD_07-2024.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/sblq9k5zty9aeot/Piano_XL_HDD_06-2024.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/bxl87kl0z92c4cy/Piano_XL_HDD_05-2024.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/ckcx6y4w8uhc8b1/Piano_XL_HDD_04-2024.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/nk3rptafuklo3yx/Piano_XL_HDD_03-2024.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/te7jchsx8unc0df/Piano_XL_HDD_02-2024.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/6dfia0w4ate0n2v/Piano_XL_HDD_01-2024.zip/file",
          },
        ],
      },
      {
        year: 2023,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/8f99tvhvj2q8z1g/Piano_XL_HDD_12-2023.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/0ryyp3uz2gi75qw/Piano_XL_HDD_11-2023.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/kloyboq5vk6a7gb/Piano_XL_HDD_10-2023.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/ehm5ej1lyj0xkha/Piano_XL_HDD_09-2023.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/flttxfev048l5rd/Piano_XL_HDD_08-2023.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/z336s6044rpanlw/Piano_XL_HDD_07-2023.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/ke8oc4qe3g9mjdt/Piano_XL_HDD_06-2023.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/x9sgpe7139ixcsn/Piano_XL_HDD_05-2023.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/nrueqbecr7b19px/Piano_XL_HDD_04-2023.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/selykelfifhwmga/Piano_XL_HDD_03-2023.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/rqzr9i2scqux05r/Piano_XL_HDD_02-2023.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/39sd2ebqhptrn9e/Piano_XL_HDD_01-2023.zip/file",
          },
        ],
      },
      {
        year: 2022,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/8cuhyysjgbtd1xr/Piano_XL_HDD_12-2022.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/kzq7ok1bbi61vts/Piano_XL_HDD_11-2022.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/rgazstsi9kxn9dc/Piano_XL_HDD_10-2022.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/56o6skc07zudgls/Piano_XL_HDD_09-2022.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/oo6s1bwpktgwh6u/Piano+XL+HDD+08-2022.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/tsi412ledig19kz/Piano_XL_HDD_07-2022.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/m248e4vnvoqluwt/Piano_XL_HDD_06-2022.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/esdetwezsi7rzb1/Piano_XL_HDD_05-2022.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/evknnw22vmsjtt9/Piano_XL_HDD_04-2022.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/pxkbzo1mrqkw9pj/Piano_XL_HDD_03-2022.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/z43fo7h8p5ejb5v/Piano_XL_HDD_02-2022.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/6jiqux8golhtjw5/Piano_XL_HDD_01-2022.zip/file",
          },
        ],
      },
      {
        year: 2021,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/4l8ruy2473t960s/Piano+XL+HDD+12-2021.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/87cs9pjhln9p0ao/Piano+XL+HDD+11-2021.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/34hj5vqj3vcjd42/Piano_XL_HDD_10-2021.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/oi71khl37csmnfu/Piano_XL_HDD_09-2021.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/gx5gbdncad4c5u9/Piano_XL_HDD_08-2021.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/r40dv82seeq0d5r/Piano+XL+HDD+07-2021.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/r10if3ovvxczvug/Piano+XL+HDD+06-2021.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/ghvalo706f2sa0j/Piano_XL_HDD_05-2021.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/xbhtfj9agvt211t/Piano_XL_HDD_04-2021.zip.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/blzi9ukr9i2qhum/Piano_XL_HDD_03-2021.zip.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/ihjlz5zn2wgiczl/Piano_XL_HDD_02-2021.zip.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/zn10cy06fj1yzvu/Piano_XL_HDD_01-2021.zip.zip/file",
          },
        ],
      },
      {
        year: 2020,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/n8ryx0qdtgcztzv/Piano_XL_HDD_12-2020.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/uba5x07itgqi55h/Piano_XL_HDD_11-2020.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/ww3bk36w8vggpgw/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/gwmdiikip4lrou5/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/g09nj9rbesk9akk/Piano_XL_HDD_08-2020.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/4r9wcr0bt6y4tla/Piano_XL_HDD_07-2020.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/kfx63gbcs9jr39k/Piano_XL_HDD_06-2020.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/en5u64rwt42uoq5/Piano_XL_HDD_05-2020.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/r0m7662llnfq0ze/Piano_XL_HDD_04-2020.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/4hszcb9zyl5hlt5/Piano_XL_HDD_03-2020.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/unpwoecynt9xs48/Piano_XL_HDD_02-2020.zip/file",
          },
        ],
      },
    ],
  },
  {
    product: "X3",
    years: [
      {
        year: 2026,
        months: [
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/1xeuxrza6pn8iux/X3_11-2026.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/fcjoszbqr1ws51t/X3_10-2026.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/89k8o25jid8gagq/X3_09-2026.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/o10hr3sgnlu4lt6/X3_08-2026.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/ctayaewohczsehv/X3_07-2026.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/cx9vb43xmqj1arl/X3_06-2026.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/ewr5y33fxim7o7w/X3_05-2026.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/lgk14wgerl90lhq/X3_04-2026.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/psmw5ygo73ek0fi/X3_03-2026.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/7n7ym9gpm0z4ym2/X3_02-2026.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/4g2jof5bt669tad/X3_01-2026.zip/file",
          },
        ],
      },
      {
        year: 2025,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/t0hh87bsyd310em/X3_12-2025.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/fnx433tfx2q48e5/X3_11-2025.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/c76y7ednmb0xxum/X3_10-2025.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/o7e4wawp4dcfa1n/X3_09-2025.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/6ym7k7scav1qefe/X3_08-2025.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/bl2crb5icjkvh0e/X3_07-2025.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/gdt35sbksgnjcet/X3_06-2025.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/g8nlbqzb1ocvg5c/X3_05-2025.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/p0x97fmd3g7e3u4/X3_04-2025.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/udzl41irc7z9u2m/X3_03-2025.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/nlu8wl78ren0kac/X3_02-2025.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/gcpr8a6xtgbi48u/X3_01-2025.zip/file",
          },
        ],
      },
      {
        year: 2024,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/mg873wqmmp56eah/X3_12-2024.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/d8ubdc9tcg7cxjn/X3_11-2024.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/i9b76vqxnuthw8h/X3_10-2024.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/x91il7njb45xsa0/X3_09-2024.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/g8l2jj1bb5hvskc/X3_08-2024.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/78wc91enl3h5aew/X3_07-2024.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/fgs4to213k6jvtb/X3_06-2024.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/38g2rgtjr2amzoc/X3_05-2024.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/7aunzkz2wn3dnnf/X3_04-2024.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/4e38mftw6kbjkzj/X3_03-2024.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/ow1d2nzkol5vpkp/X3_02-2024.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/3buwycaidn8mv4h/X3_01-2024.zip/file",
          },
        ],
      },
      {
        year: 2023,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/m4hp2osszumlf9o/X3_12-2023.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/vxzyclwuk4o6vvv/X3_11-2023.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/r1vetl4u4zppjmy/X3_10-2023.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/l6ix2cl7xw9z29i/X-3_09-2023.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/12702tjfqn4xfkv/X-3_08-2023.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/cjh421ensit8693/X-3_07-2023.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/8to0nkgeo8vsc3u/X-3_06-2023.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/uwmvrumjcdemvjc/X-3_05-2023.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/qpiizmk6f8gjgjd/X-3_04-2023.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/wge02fpexjw5vb8/X-3_03-2023.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/bktjs02knrl4dtm/X-3_02-2023.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/i2wcemyxy7o7qkn/X-3_01-2023.zip/file",
          },
        ],
      },
      {
        year: 2022,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/fkvss2tbz7jeo5j/X-3_12-2022.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/kp6vcqlp5h74l1o/X-3_11-2022.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/4lgey0i814kuh2k/X-3_10-2022.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/h8c4cqbnonzcey5/X-3_09-2022.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/xhmkmhdgydozvl8/X-3+08-2022.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/vwbf89bxvlcy5p1/X-3_07-2022.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/erdh69ar7anbtmu/X-3_06-2022.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/f5hhqlnohv1n1aj/X-3_05-2022.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/jo8vepucc1pazjj/X-3_04-2022.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/xal685aesve2a6v/X-3_03-2022.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/8gdexnigzyyp5rw/X-3_02-2022.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/epgik9vmajg6ytw/X-3_01-2022.zip/file",
          },
        ],
      },
      {
        year: 2021,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/08a0djx6o4jlkb0/X-3+12-2021.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/h73lcsv9bxmpk77/X-3_11-2021.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/mde46mo95t46byc/X-3_10-2021.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/42siivn8hktt75p/X-3_09-2021.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/4tcnv30m6cnqp8c/X-3_08-2021.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/r40dv82seeq0d5r/X-3+07-2021.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/pfu757fc0re1r13/X-3+06-2021.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/5pkwfdsph69j4en/X-3_05-2021.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/aguxu1b48b2om4u/X-3_04-2021.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/6svkyyst4koiw9k/X-3_03-2021.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/6hsr2pjnleq925z/X-3_02-2021.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/4z8qxgzlbdbog72/X-3_01-2021.zip/file",
          },
        ],
      },
      {
        year: 2020,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/jy82lsigdxfeu0v/X-3_12-2020.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/swjzn927zlynmv2/X-3_11-2020.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/s90qq72tr7tvcp0/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/or3ckhc4xl2cu8k/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/3wpe5nbxx330zdf/X-3_08-2020.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/8nm3yobu1lllw4m/X-3_07-2020.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/54x8ndfzbyssji1/X-3_06-2020.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/wadk58pb39n9k35/X-3_05-2020.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/arqml2sa76d57vl/X-3_04-2020.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/jjqsvn9f1oyqvvc/X-3_03-2020.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/8p0bnk6fyr12obp/X-3_02-2020.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/rpf8yy4bc08vrxm/X-3_01-2020.zip/file",
          },
        ],
      },
      {
        year: 2019,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/ibuz70jyed6ig3a/X-3_12-2019.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/puzgn5lh30tk72r/X-3_11-2019.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/8o3e1ccjt5dqrvj/X-3_10-2019.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/jj2ua5afu16lo5r/X-3_09-2019.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/1eeepsyplv7buji/X-3_08-2019.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/5wm080zgy6ntw6w/X-3_07-2019.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/d4b4v2abfxicvfa/X-3_06-2019.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/khs0jsnsxgjjgkr/X-3_05-2019.zip/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/un8ho3tprupax8b/X-3_04-2019.zip/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/322l4a4o792x6xw/X-3_03-2019.zip/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/ay66pr8dlea7d8u/X-3_02-2019.zip/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/816ddduw7t63yps/X-3_01-2019.zip/file",
          },
        ],
      },
      {
        year: 2018,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/40t01a8h5a0yf3u/X-3_12-2018%25282%2529.zip/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/0m792p3044taycg/X-3_11-2018.zip/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/89kf9r4upoyf7zr/X-3_10-2018.zip/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/t8ubq6bi3pr259f/X-3_09-2018.zip/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/i3h5xck32agby3a/X-3_08-2018.zip/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/70bx7v3l54monpt/X-3_07-2018.zip/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/smst4kuc3nev6r6/X-3_06-2018.zip/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/57qgjvd8zln1hvh/X-3_05-2018_%282%29.zip",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/lgkgrq92o9loq19/X-3_04-2018.zip",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/2b7cmv856k6vzm2/MARCH_2018.zip",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/073cr3b7xctbstg/X3_02-2018.zip",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/0dzkchnsfncz8w0/X-3_01-2018.zip",
          },
        ],
      },
      {
        year: 2017,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/uyt322w5dycncoc/X3_DEC_2017.zip",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/rcqqg7q1ieef373/X3_NOV_2017.zip",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/256875af45fwxxv/X3_OCT_2017.zip",
          },
        ],
      },
    ],
  },
  {
    product: "PK10/Piano XL SD/Piano 1.6",
    procedure: "Procedure",
    procedureLink:
      "https://platinumkaraoke.com/pages/piano-1-6-piano-xl-sd-pk-10-song-update-procedure",
    years: [
      {
        year: 2026,
        months: [
          {
            volume: "Volume 108",
            link: "https://www.mediafire.com/file_premium/gh5w9ojvdw9sbpa/Volume_108.zip/file",
          },
          {
            volume: "Volume 107",
            link: "https://www.mediafire.com/file_premium/4w9o5bt4jb0x28o/Volume_107.zip/file",
          },
        ],
      },
    ],
  },
  {
    product: "Tango/CX15/LX15/DK88/DK65",
    procedure: "Procedure",
    procedureLink:
      "https://platinumkaraoke.com/pages/piano-1-6-piano-xl-sd-pk-10-song-update-procedure",
    years: [
      {
        year: 2026,
        months: [
          {
            volume: "Volume 35",
            link: "https://www.mediafire.com/file_premium/k9xprru5d1rexpl/Volume_35.zip/file",
          },
          {
            volume: "Volume 34",
            link: "https://www.mediafire.com/file_premium/lca3nsptt0bime1/Volume_34.zip/file",
          },
        ],
      },
    ],
  },
];

// import { songUpdate } from "./songUpdateData.js"

const html = `
   <div class="song-update-header">
      <a
         class="song-update-procedure"
         href="https://platinumkaraoke.com/pages/song-update-procedure-mac-and-windows"
         target="_blank"
      >
         <div>Song Update Procedure</div>
      </a>
      <h2>SONG UPDATE</h2>
      <a
         class="song-authentication"
         href="https://platinumkaraoke.com/pages/what-is-song-authentication"
         target="_blank"
      >
         <div>Song Authentication</div>
      </a>
   </div>

   ${songUpdate
     .map(
       ({ product, years, procedureLink, procedure }) => `
      <details class="products">
      <summary class="product">${product}</summary>

         ${years
           .map(
             ({ year, months }) => `
            <details class="years">
               <summary class="year">${year}</summary>

               ${months
                 .map(
                   ({ month, volume, link }) => `
                  <div class="month">
                     <p>${month ? month : `${volume} <a href="${procedureLink}" class="procedure">${procedure || ""}</a>`}</p>


                     <a href="${link}" target="_blank">
                        <img src="https://cdn.shopify.com/s/files/1/2581/7224/files/gempages_475038571602903838-28e7b256-cd44-4ab9-8401-1dd8dad653b0.png?v=1741678173" width="33" height="28"/>
                     </a>
                  </div>
               `,
                 )
                 .join("")}

            </details>
         `,
           )
           .join("")}

      </details>
   `,
     )
     .join("")}
`;

function initSongUpdate() {
  const root = document.getElementById("song-update-root");

  if (!root) return;

  root.innerHTML = html;

  const products = document.querySelectorAll(".products");
  products.forEach((product) => {
    product.addEventListener("toggle", () => {
      if (product.hasAttribute("open")) {
        products.forEach((p) => {
          if (p !== product) {
            p.removeAttribute("open");
          }
        });
      }
    });
  });

  const years = document.querySelectorAll(".years");
  years.forEach((year) => {
    year.addEventListener("toggle", () => {
      if (year.open) {
        years.forEach((y) => {
          if (y !== year) {
            y.removeAttribute("open");
          }
        });
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initSongUpdate);
document.addEventListener("shopify:section:load", initSongUpdate);
